import { Component } from "react"
import PropTypes from "prop-types"
import { noop } from "lodash"
import { CardContent } from "@mui/material"
import Steps from "./components/steps"
import { STEPPER_ACTIONS } from "./constants"
import "./style.scss"

const { SUBMIT, CANCEL, BACK, GOTOSTEP } = STEPPER_ACTIONS

class StepperContainer extends Component {
  static propTypes = {
    className: PropTypes.string,
    disableVariables: PropTypes.object,
    activeStep: PropTypes.number.isRequired,
    steps: PropTypes.array.isRequired,
    goBack: PropTypes.func,
    goToStep: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
    stepComponent: PropTypes.object.isRequired,
    subHeaderComponent: PropTypes.object,
    track: PropTypes.func,
  }

  onSubmit = (...args) => {
    const { onSubmit, track } = this.props
    track(SUBMIT)
    onSubmit(...args)
  }

  onCancel = (...args) => {
    const { onCancel, track } = this.props
    track(CANCEL)
    onCancel(...args)
  }

  goBack = (...args) => {
    const { goBack, track } = this.props
    track(BACK)
    goBack(...args)
  }

  goToStep = (...args) => {
    const { goToStep, track } = this.props
    track(GOTOSTEP)
    goToStep(...args)
  }

  render() {
    const {
      disableVariables,
      stepComponent,
      steps,
      activeStep,
      subHeaderComponent,
      goBack,
      goToStep,
    } = this.props
    return <div className="components_stepper-container">
      <div className="stepper-wrapper">
        <CardContent className="stepper-content" classes={{ root: "stepper-content-root" }}>
          <div className="flex-wrapper">
            <Steps
              disableVariables={disableVariables}
              activeStep={activeStep}
              steps={steps}
              onSubmit={this.onSubmit}
              onCancel={this.onCancel}
              goBack={goBack ? this.goBack : undefined}
              goToStep={goToStep ? this.goToStep : undefined}
              subHeaderComponent={subHeaderComponent}
            />
            <div className="step-children-wrapper">
              {stepComponent}
            </div>
          </div>
        </CardContent>
      </div>
    </div>
  }
}

StepperContainer.defaultProps = {
  track: noop,
}

export default StepperContainer
